import React, { useContext } from 'react';

import { DeleteIcon } from '@vlabs/icons';
import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';
import { TableContext } from '@vlabs/uikit/components/table/table-context';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function DeleteCell({
  row = undefined,
  buttonProps = undefined,
}) {
  const { actions, onActions } = useContext(TableContext);
  const onDelete = actions.onDeleteRow?.getHandlerIfCan?.(row.original);
  const permissions = onActions?.onDeleteRow?.permissions;
  const label = actions.onDeleteRow?.label;
  const { t } = useTranslation();

  if (!onDelete) return null;

  return (
    <ButtonWithPermissions
      data-testid="deleteCell"
      icon={<DeleteIcon />}
      kind="negative"
      onClick={() => onDelete(row.original)}
      permissions={permissions}
      title={label || t('uikit:table.actions.delete')}
      variant="dimmed"
      {...(buttonProps || {})}
    />
  );
}

DeleteCell.propTypes = ({
  row: PropTypes.objectOf(PropTypes.any),
  buttonProps: PropTypes.object,
});

export { DeleteCell };
